import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import _ from 'lodash';

import FieldSelectWithOther from './FieldSelectWithOther.jsx';
import FieldTextBox from './FieldTextBox.jsx';
import FieldDate from './FieldDate.jsx';
import { fetchDrivers } from '../../actions/driver';
import { fetchSeries } from '../../actions/series';
import { fetchTracks } from '../../actions/track';

export class BasicInfo extends React.Component {
  componentDidMount() {
    this.props.fetchDrivers();
    this.props.fetchSeries({ raceSurface: 'pavement' });
    this.props.fetchTracks({ raceSurface: ['Asphalt', 'Concrete'] });
  }

  renderAdditionalFields() {
    const shouldShowAdditionalFields = _.includes(['race', 'reflection'], this.props.formType);

    if (shouldShowAdditionalFields) {
      return (
        <Row style={{ display: shouldShowAdditionalFields }}>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Crew Chief Name" field="crewChiefName" />
          </Col>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Spotter Name" field="spotterName" />
          </Col>
        </Row>
      );
    }

    return null;
  }

  render() {
    const { drivers, series, tracks } = this.props;

    return (
      <div>
        <Row>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={drivers}
              defaultEmptyOption="Driver Name *"
              field="driverName"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={series}
              defaultEmptyOption="Series *"
              field="series"
            />
          </Col>
          <Col xs={12} sm={4}>
            <FieldSelectWithOther
              options={tracks}
              defaultEmptyOption="Track *"
              field="track"
            />
          </Col>
        </Row>
        {this.renderAdditionalFields()}
        <Row>
          <Col xs={12} sm={6}>
            <FieldTextBox placeholder="Team Name" field="teamName" />
          </Col>
          <Col xs={12} sm={6}>
            <FieldDate />
          </Col>
        </Row>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  formType: state.form.formType,
  drivers: state.driver.result || [],
  series: state.series.result || [],
  tracks: state.track.result || [],
});

export default connect(
  mapStateToProps,
  { fetchDrivers, fetchSeries, fetchTracks },
)(BasicInfo);
